import React from "react";
import { FOOTER } from "@/constants/testIds";
import { ZInCircle } from "@/components/logos/Marks";

const cols = [
  {
    title: "Product",
    links: ["Features", "Product", "How it works", "FAQ"],
    ids: ["features", "product", "how-it-works", "faq"],
  },
  {
    title: "Company",
    links: ["About", "Careers", "Security", "Contact"],
    ids: [null, null, null, "contact"],
  },
  {
    title: "Legal",
    links: ["Privacy", "Terms", "HIPAA", "BAA"],
    ids: [null, null, null, null],
  },
];

export const Footer = () => {
  const goTo = (id) => {
    if (!id) return;
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <footer
      data-testid={FOOTER.section}
      className="bg-zinc-950 text-white pt-20 pb-12"
    >
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="grid grid-cols-2 md:grid-cols-5 gap-10">
          <div className="col-span-2">
            <div className="flex items-center gap-2.5">
              <ZInCircle
                variant="monolith"
                size="h-9 w-9"
                bg="bg-white"
                fg="text-zinc-950"
              />
              <span className="font-display text-lg font-semibold tracking-tight">
                Zaplee<span className="text-[#7AA2FF]">.ai</span>
              </span>
            </div>
            <p className="mt-5 max-w-sm text-sm text-zinc-400 leading-relaxed">
              AI-native revenue cycle management for healthcare practices,
              multi-specialty groups and billing companies.
            </p>
          </div>

          {cols.map((c) => (
            <div key={c.title}>
              <div className="font-mono-label text-[10px] text-zinc-500">
                {c.title}
              </div>
              <ul className="mt-5 space-y-3">
                {c.links.map((l, i) => (
                  <li key={l}>
                    <button
                      onClick={() => goTo(c.ids[i])}
                      className="text-sm text-zinc-300 hover:text-white transition-colors"
                    >
                      {l}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
          <p className="text-xs text-zinc-500">
            © {new Date().getFullYear()} Zaplee.ai · All rights reserved.
          </p>
          <p className="text-xs text-zinc-500">
            HIPAA-aligned · SOC 2 in progress · Built for healthcare RCM
          </p>
        </div>
      </div>
    </footer>
  );
};
